;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { createAutomationTour } from "@/features/onboarding-tours/registry/tours/automations";
import {
	addDashboardViewTour,
	deleteDisableDashboardViewTour,
	editDashboardViewTour,
} from "@/features/onboarding-tours/registry/tours/dashboard-views";
import {
	deleteDataProviderTour,
	manualSyncPortfolioTour,
} from "@/features/onboarding-tours/registry/tours/data-integrations";
import { configureLeaderboardTour } from "@/features/onboarding-tours/registry/tours/leaderboard";
import {
	addDataProviderGuardTour,
	addDataProviderSettingsTour,
} from "@/features/onboarding-tours/registry/tours/pipeline-tours";
import { shareAViewTour } from "@/features/onboarding-tours/registry/tours/share-view";
import {
	inviteTeamMemberTour,
	workspaceNavigationTour,
} from "@/features/onboarding-tours/registry/tours/workspace-team";
import type { TourDefinition } from "@/features/onboarding-tours/types/tour-definition";

export const ALL_TOUR_DEFINITIONS: TourDefinition[] = [
	addDataProviderGuardTour,
	addDataProviderSettingsTour,
	deleteDataProviderTour,
	manualSyncPortfolioTour,
	inviteTeamMemberTour,
	addDashboardViewTour,
	editDashboardViewTour,
	deleteDisableDashboardViewTour,
	workspaceNavigationTour,
	createAutomationTour,
	shareAViewTour,
	configureLeaderboardTour,
];

export const TOUR_DEFINITION_BY_ID = Object.fromEntries(
	ALL_TOUR_DEFINITIONS.map((tour) => [tour.id, tour]),
) as Record<TourDefinition["id"], TourDefinition>;

export function getTourDefinition(
	tourId: TourDefinition["id"],
): TourDefinition | undefined {
	return TOUR_DEFINITION_BY_ID[tourId];
}
